// extracted by mini-css-extract-plugin
export default {"main-container":"Signup_main-container__El7re"};